import Vue from "vue";

/**
 * 保存[协商证明/合同]
 * @param data
 * @returns {*}
 */
export function orderCovenantStore(data) {
    return Vue.axios({
        url: '/api/order_covenant/store',
        method: 'post',
        data
    })
}

/**
 * 列表[协商证明/合同]
 * @param data
 * @returns {*}
 */
export function orderCovenantQuery(data) {
    return Vue.axios({
        url: '/api/order_covenant/query',
        method: 'post',
        data
    })
}

export function orderCovenantSummation() {
    return Vue.axios({
        url: '/api/order_covenant/summation',
        method: 'get'
    })
}

export function orderCovenantDetail(params) {
    return Vue.axios({
        url: '/api/order_covenant/detail',
        method: 'get',
        params
    })
}

/**
 * 下拉列表[协商证明/合同]
 * @param params
 * @returns {*}
 */
export function orderCovenantOptions(params) {
    return Vue.axios({
        url: '/api/order_covenant/options',
        method: 'get',
        params
    })
}

/**
 *
 * @param data
 * @returns {*}
 */
export function orderCovenantDoSign(data) {
    return Vue.axios({
        url: '/api/order_covenant/doSignOrders',
        method: 'post',
        data
    })
}

/**
 *
 * @param data
 * @returns {*}
 */
export function orderCovenantUnDoSign(data) {
    return Vue.axios({
        url: '/api/order_covenant/undoSignOrders',
        method: 'post',
        data
    })
}

export function orderCovenantDelete(data) {
    return Vue.axios({
        url: '/api/order_covenant/delete',
        method: 'post',
        data
    })
}

/**
 *
 * @param params
 * @returns {*}
 */
export function orderCovenantSignPage(params) {
    return Vue.axios({
        url: '/api/order_covenant/getSignMapPage',
        method: 'get',
        params
    })
}

/**
 * 查看合同下的附件文件列表
 * @param params
 * @returns {*}
 */
export function orderCovenantFileList(params) {
    return Vue.axios({
        url: '/api/order_covenant/files',
        method: 'get',
        params
    })
}
